
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-main-header--wrapper{
  position:sticky;
  top:0;
  z-index:3;
}

.se-main-header{
  display:flex;
  flex-direction:column;
}

@media (min-width: 768px){

.se-main-header{
    width:100%;
    box-shadow:0px 35px 43px -20px rgba(0, 0, 0, 0.05)
}

    .se-main-header:hover{
      box-shadow:none;
    }
  }

.se-main-header--main{
  display:flex;
  flex-direction:column;
  width:100%;
  background-color:var(--brand-neutral-white);
}

@media (min-width: 768px){

.se-main-header--main{
    margin:0 auto;
    padding:0
}
  }

.se-main-header--logo{
  display:flex;
  width:100%;
  max-width:110px;
}

@media (min-width: 1024px){

.se-main-header--logo{
    max-width:180px !important
}
  }

@media (min-width: 768px) and (max-width: 1023px){

.se-main-header--logo{
    max-width:130px
}
  }

.se-main-header--search{
  display:flex;
  align-items:center;
  justify-content:flex-end;
  width:100%;
}

@media (min-width: 768px){

.se-main-header--search{
    margin-left:2rem
}
  }

.se-main-header--search se-button:first-of-type{
    width:max-content;
    padding-right:1em;
  }

@media (min-width: 1024px){

.se-main-header--search se-button:first-of-type{
      padding-right:3em
  }
    }

@media (min-width: 768px) and (max-width: 1023px){

.se-main-header--search se-button:first-of-type{
      padding-right:2em
  }
    }

.se-main-header--top-content{
  display:flex;
  align-items:center;
  min-height:70px;
}

.se-main-header--search-slot{
  position:relative;
}

.se-main-header--nav-search{
  display:flex;
  width:100%;
}

.se-main-header--logo-search{
  display:flex;
  justify-content:space-between;
  align-items:center;
  height:70px;
  background-color:var(--brand-neutral-white);
  width:100%;
}

.se-main-header--nav-utility{
  display:flex;
  flex-direction:column;
}

slot[name='nav']{
  display:flex;
  background-color:var(--gray-100);
  padding:0;
  width:100%;
}

@media (min-width: 768px){

slot[name='nav']{
    background-color:var(--brand-neutral-white)
}
  }

slot[name='utility']{
  display:flex;
  background-color:var(--brand-primary-3);
}

@media (min-width: 768px){

slot[name='utility']{
    padding:0;
    background-color:none
}
  }

se-container{
  display:flex;
  flex-direction:row;
  align-items:center;
  width:100%;
}

.se-main-header--nav-mobile{
  background-color:var(--gray-100);
}

.closed{
  display:none;
}

slot[name='nav']::slotted(*){
  display:flex;
  width:100%;
}

.overlay{
  position:absolute;
  left:0;
  display:block;
  z-index:2;
  width:100%;
  height:100% !important;
  background-color:#13327c;
  opacity:0.6;
}

.scroll-locked{
  height:100vh;
  overflow-y:scroll;
  z-index:4;
  width:100%;
  position:absolute;
  top:0;
}

@media (min-width: 768px){

.scroll-locked{
    height:unset;
    position:relative;
    overflow-y:visible
}
  }
`;